// extracted by mini-css-extract-plugin
export default {"wlarge":"Lines_wlarge__rlMIJ","wsmall":"Lines_wsmall__L5MBG"};